import * as React from "react";
import { RouteComponentProps } from "react-router";
import { observer } from "mobx-react";
import RegisterOrderComponent from './order-register'

type Props = RouteComponentProps<{ entityId?: string }>;

@observer
export class OrderRegisterManagement extends React.Component<Props> {
  static PATH = "/orderRegisterSheet";
  static NEW_SUBPATH = "new";

  render() {
    const { entityId } = this.props.match.params;

    return (
      <>
        {entityId && (
          <RegisterOrderComponent entityId={entityId}/>
        )}
      </>
    );
  }
}
